export default {"src":"https://dap-o2cg76iga-dap-rewrite.vercel.app/_next/static/media/MyProfileChevronDown.43414bc1.svg","height":49,"width":48};